import {
  GETDENTALCOMPLAINTCHILDILLNESS,
  CREATEDENTALCOMPLAINTCHILDILLNESS,
  DELETEDENTALCOMPLAINTCHILDILLNESS,
  UPDATEDENTALCOMPLAINTCHILDILLNESS,
  GETDENTALCOMPLAINTADULTILLNESS,
  CREATEDENTALCOMPLAINTADULTILLNESS,
  DELETEDENTALCOMPLAINTADULTILLNESS,
  UPDATEDENTALCOMPLAINTADULTILLNESS,
  GETDENTALCOMPLAINTHEALTHMAINT,
  CREATEDENTALCOMPLAINTHEALTHMAINT,
  DELETEDENTALCOMPLAINTHEALTHMAINT,
  UPDATEDENTALCOMPLAINTHEALTHMAINT,
  GETDENTALCOMPLAINTRELATION,
  CREATEDENTALCOMPLAINTRELATION,
  DELETEDENTALCOMPLAINTRELATION,
  UPDATEDENTALCOMPLAINTRELATION,
  GETDENTALAPPITITLE,
  CREATEDENTALAPPITITLE,
  DELETEDENTALAPPITITLE,
  UPDATEDENTALAPPITITLE,
  GETDENTALDIGESTIVETRACT,
  CREATEDENTALDIGESTIVETRACT,
  DELETEDENTALDIGESTIVETRACT,
  UPDATEDENTALDIGESTIVETRACT,
  GETDENTALBOWEL,
  CREATEDENTALBOWEL,
  DELETEDENTALBOWEL,
  UPDATEDENTALBOWEL,
  GETDENTALSLIP,
  CREATEDENTALSLIP,
  DELETEDENTALSLIP,
  UPDATEDENTALSLIP,
  GETDENTALADDICTIONS,
  CREATEDENTALADDICTIONS,
  DELETEDENTALADDICTIONS,
  UPDATEDENTALADDICTIONS,
  GETDENTALHIGHRISKANDBEHAVIOR,
  CREATEDENTALHIGHRISKANDBEHAVIOR,
  DELETEDENTALHIGHRISKANDBEHAVIOR,
  UPDATEDENTALHIGHRISKANDBEHAVIOR,
  GETDENTALPOSITIONDURINGWORK,
  CREATEDENTALPOSITIONDURINGWORK,
  DELETEDENTALPOSITIONDURINGWORK,
  UPDATEDENTALPOSITIONDURINGWORK,
  GETDENTALNATUREOFWORK,
  CREATEDENTALNATUREOFWORK,
  DELETEDENTALNATUREOFWORK,
  UPDATEDENTALNATUREOFWORK,
  GETDENTALALLOPATHIC,
  CREATEDENTALALLOPATHIC,
  DELETEDENTALALLOPATHIC,
  UPDATEDENTALALLOPATHIC,
  GETDENTALAYURVEDA,
  CREATEDENTALAYURVEDA,
  DELETEDENTALAYURVEDA,
  UPDATEDENTALAYURVEDA,
  GETDENTALHOMEOPATHIC,
  CREATEDENTALHOMEOPATHIC,
  DELETEDENTALHOMEOPATHIC,
  UPDATEDENTALHOMEOPATHIC,
  GETDENTALOTHERMEDICINE,
  CREATEDENTALOTHERMEDICINE,
  DELETEDENTALOTHERMEDICINE,
  UPDATEDENTALOTHERMEDICINE,
  GETDENTALANXIETY,
  CREATEDENTALANXIETY,
  DELETEDENTALANXIETY,
  UPDATEDENTALANXIETY,
  GETDENTALDEPRESSION,
  CREATEDENTALDEPRESSION,
  DELETEDENTALDEPRESSION,
  UPDATEDENTALDEPRESSION,
  GETDENTALIRRITABILITY,
  CREATEDENTALIRRITABILITY,
  DELETEDENTALIRRITABILITY,
  UPDATEDENTALIRRITABILITY,
  GETDENTALEUPHORIA,
  CREATEDENTALEUPHORIA,
  DELETEDENTALEUPHORIA,
  UPDATEDENTALEUPHORIA,
  GETDENTALOBSESSION,
  CREATEDENTALOBSESSION,
  DELETEDENTALOBSESSION,
  UPDATEDENTALOBSESSION,
  GETDENTALNEUROSIS,
  CREATEDENTALNEUROSIS,
  DELETEDENTALNEUROSIS,
  UPDATEDENTALNEUROSIS,
  GETDENTALDEPERSONALIZATION,
  CREATEDENTALDEPERSONALIZATION,
  DELETEDENTALDEPERSONALIZATION,
  UPDATEDENTALDEPERSONALIZATION,
  GETDENTALMENSTRUALCYCLE,
  CREATEDENTALMENSTRUALCYCLE,
  DELETEDENTALMENSTRUALCYCLE,
  UPDATEDENTALMENSTRUALCYCLE,
  GETDENTALFILLINGMATERIAL,
  CREATEDENTALFILLINGMATERIAL,
  DELETEDENTALFILLINGMATERIAL,
  UPDATEDENTALFILLINGMATERIAL,
  GETDENTALFILLINGMATERIALUNIT,
  CREATEDENTALFILLINGMATERIALUNIT,
  DELETEDENTALFILLINGMATERIALUNIT,
  UPDATEDENTALFILLINGMATERIALUNIT,
  GETDENTALCOVERINGMATERIAL,
  CREATEDENTALCOVERINGMATERIAL,
  DELETEDENTALCOVERINGMATERIAL,
  UPDATEDENTALCOVERINGMATERIAL,
  GETDENTALCOVERINGMATERIALUNIT,
  CREATEDENTALCOVERINGMATERIALUNIT,
  DELETEDENTALCOVERINGMATERIALUNIT,
  UPDATEDENTALCOVERINGMATERIALUNIT,
  GETDENTALSTATUS,
  CREATEDENTALSTATUS,
  DELETEDENTALSTATUS,
  UPDATEDENTALSTATUS,
  GETDENTALDIET,
  CREATEDENTALDIET,
  UPDATEDENTALDIET,
  DELETEDENTALDIET,
  CREATEDENTALNATUREOFDELIVERYHIST,
  GETDENTALNATUREOFDELIVERYHIST,
  UPDATEDENTALNATUREOFDELIVERYHIST,
  DELETEDENTALNATUREOFDELIVERYHIST,
  CREATESETUPDIAGNOSIS,
  GETSETUPDIAGNOSIS,
  UPDATESETUPDIAGNOSIS,
  DELETESETUPDIAGNOSIS,
  GETSETUPLABWORKMATERIALUSED,
  CREATESETUPLABWORKMATERIALUSED,
  UPDATESETUPLABWORKMATERIALUSED,
  DELETESETUPLABWORKMATERIALUSED,
  GETSETUPLABWORKUNIT,
  CREATESETUPLABWORKUNIT,
  UPDATESETUPLABWORKUNIT,
  DELETESETUPLABWORKUNIT,
  GETSETUPLABWORKSHADE,
  CREATESETUPLABWORKSHADE,
  UPDATESETUPLABWORKSHADE,
  DELETESETUPLABWORKSHADE,
  GETSETUPLABWORKSTATUS,
  CREATESETUPLABWORKSTATUS,
  UPDATESETUPLABWORKSTATUS,
  DELETESETUPLABWORKSTATUS,
  GETSETUPLABWORKLABNAME,
  CREATESETUPLABWORKLABNAME,
  UPDATESETUPLABWORKLABNAME,
  DELETESETUPLABWORKLABNAME,
  GETSETUPLABWORKRESTORATION,
CREATESETUPLABWORKRESTORATION,
UPDATESETUPLABWORKRESTORATION,
DELETESETUPLABWORKRESTORATION,
} from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case CREATEDENTALCOMPLAINTCHILDILLNESS:
      return {
        ...state,
        dentalComplaintChildillnessSaveStatus: action.payload.success,
      };
    case GETDENTALCOMPLAINTCHILDILLNESS:
      return {
        ...state,
        dentalComplaintChildillnessList: action.payload.data,
      };
    case UPDATEDENTALCOMPLAINTCHILDILLNESS:
      return {
        ...state,
        dentalComplaintChildillnessUpdateStatus: action.payload.success,
      };

    case DELETEDENTALCOMPLAINTCHILDILLNESS:
      return {
        ...state,
        dentalComplaintChildillnessDeleteStatus: action.payload.success,
      };
    case CREATEDENTALCOMPLAINTADULTILLNESS:
      return {
        ...state,
        dentalComplaintAdultillnessSaveStatus: action.payload.success,
      };
    case GETDENTALCOMPLAINTADULTILLNESS:
      return {
        ...state,
        dentalComplaintAdultillnessList: action.payload.data,
      };
    case UPDATEDENTALCOMPLAINTADULTILLNESS:
      return {
        ...state,
        dentalComplaintAdultillnessUpdateStatus: action.payload.success,
      };

    case DELETEDENTALCOMPLAINTADULTILLNESS:
      return {
        ...state,
        dentalComplaintAdultillnessDeleteStatus: action.payload.success,
      };
    case CREATEDENTALCOMPLAINTHEALTHMAINT:
      return {
        ...state,
        dentalComplaintHealthMainSaveStatus: action.payload.success,
      };
    case GETDENTALCOMPLAINTHEALTHMAINT:
      return {
        ...state,
        dentalComplaintHealthMainList: action.payload.data,
      };
    case UPDATEDENTALCOMPLAINTHEALTHMAINT:
      return {
        ...state,
        dentalComplaintHealthMainUpdateStatus: action.payload.success,
      };

    case DELETEDENTALCOMPLAINTHEALTHMAINT:
      return {
        ...state,
        dentalComplaintHealthMainDeleteStatus: action.payload.success,
      };

    case CREATEDENTALCOMPLAINTRELATION:
      return {
        ...state,
        dentalComplaintRelationSaveStatus: action.payload.success,
      };
    case GETDENTALCOMPLAINTRELATION:
      return {
        ...state,
        dentalComplaintRelationList: action.payload.data,
      };
    case UPDATEDENTALCOMPLAINTRELATION:
      return {
        ...state,
        dentalComplaintRelationUpdateStatus: action.payload.success,
      };

    case DELETEDENTALCOMPLAINTRELATION:
      return {
        ...state,
        dentalComplaintRelationDeleteStatus: action.payload.success,
      };

    case CREATEDENTALAPPITITLE:
      return {
        ...state,
        dentalappetitleSaveStatus: action.payload.success,
      };
    case GETDENTALAPPITITLE:
      return {
        ...state,
        dentalappetitleList: action.payload.data,
      };
    case UPDATEDENTALAPPITITLE:
      return {
        ...state,
        dentalappetitleUpdateStatus: action.payload.success,
      };

    case DELETEDENTALAPPITITLE:
      return {
        ...state,
        dentalappetitleDeleteStatus: action.payload.success,
      };

    case CREATEDENTALDIGESTIVETRACT:
      return {
        ...state,
        dentaldigestivetractSaveStatus: action.payload.success,
      };
    case GETDENTALDIGESTIVETRACT:
      return {
        ...state,
        dentaldigestivetractList: action.payload.data,
      };
    case UPDATEDENTALDIGESTIVETRACT:
      return {
        ...state,
        dentaldigestivetractUpdateStatus: action.payload.success,
      };

    case DELETEDENTALDIGESTIVETRACT:
      return {
        ...state,
        dentaldigestivetractDeleteStatus: action.payload.success,
      };

    case CREATEDENTALBOWEL:
      return {
        ...state,
        dentalbowelSaveStatus: action.payload.success,
      };
    case GETDENTALBOWEL:
      return {
        ...state,
        dentalbowelList: action.payload.data,
      };
    case UPDATEDENTALBOWEL:
      return {
        ...state,
        dentalbowelUpdateStatus: action.payload.success,
      };

    case DELETEDENTALBOWEL:
      return {
        ...state,
        dentalbowelDeleteStatus: action.payload.success,
      };

    case CREATEDENTALSLIP:
      return {
        ...state,
        dentalslipSaveStatus: action.payload.success,
      };
    case GETDENTALSLIP:
      return {
        ...state,
        dentalslipList: action.payload.data,
      };
    case UPDATEDENTALSLIP:
      return {
        ...state,
        dentalslipUpdateStatus: action.payload.success,
      };

    case DELETEDENTALSLIP:
      return {
        ...state,
        dentalslipDeleteStatus: action.payload.success,
      };

    case CREATEDENTALADDICTIONS:
      return {
        ...state,
        dentaladdictionsSaveStatus: action.payload.success,
      };
    case GETDENTALADDICTIONS:
      return {
        ...state,
        dentaladdictionsList: action.payload.data,
      };
    case UPDATEDENTALADDICTIONS:
      return {
        ...state,
        dentaladdictionsUpdateStatus: action.payload.success,
      };

    case DELETEDENTALADDICTIONS:
      return {
        ...state,
        dentaladdictionsDeleteStatus: action.payload.success,
      };

    case CREATEDENTALHIGHRISKANDBEHAVIOR:
      return {
        ...state,
        dentalhighriskandbehaviorSaveStatus: action.payload.success,
      };
    case GETDENTALHIGHRISKANDBEHAVIOR:
      return {
        ...state,
        dentalhighriskandbehaviorList: action.payload.data,
      };
    case UPDATEDENTALHIGHRISKANDBEHAVIOR:
      return {
        ...state,
        dentalhighriskandbehaviorUpdateStatus: action.payload.success,
      };

    case DELETEDENTALHIGHRISKANDBEHAVIOR:
      return {
        ...state,
        dentalhighriskandbehaviorDeleteStatus: action.payload.success,
      };

    case CREATEDENTALPOSITIONDURINGWORK:
      return {
        ...state,
        dentalpositionduringworkSaveStatus: action.payload.success,
      };
    case GETDENTALPOSITIONDURINGWORK:
      return {
        ...state,
        dentalpositionduringworkList: action.payload.data,
      };
    case UPDATEDENTALPOSITIONDURINGWORK:
      return {
        ...state,
        dentalpositionduringworkUpdateStatus: action.payload.success,
      };

    case DELETEDENTALPOSITIONDURINGWORK:
      return {
        ...state,
        dentalpositionduringworkDeleteStatus: action.payload.success,
      };

    case CREATEDENTALNATUREOFWORK:
      return {
        ...state,
        dentalnatureofworkSaveStatus: action.payload.success,
      };
    case GETDENTALNATUREOFWORK:
      return {
        ...state,
        dentalnatureofworkList: action.payload.data,
      };
    case UPDATEDENTALNATUREOFWORK:
      return {
        ...state,
        dentalnatureofworkUpdateStatus: action.payload.success,
      };

    case DELETEDENTALNATUREOFWORK:
      return {
        ...state,
        dentalnatureofworkDeleteStatus: action.payload.success,
      };

    case CREATEDENTALALLOPATHIC:
      return {
        ...state,
        dentalallopathicSaveStatus: action.payload.success,
      };
    case GETDENTALALLOPATHIC:
      return {
        ...state,
        dentalallopathicList: action.payload.data,
      };
    case UPDATEDENTALALLOPATHIC:
      return {
        ...state,
        dentalallopathicUpdateStatus: action.payload.success,
      };

    case DELETEDENTALALLOPATHIC:
      return {
        ...state,
        dentalallopathicDeleteStatus: action.payload.success,
      };

    case CREATEDENTALAYURVEDA:
      return {
        ...state,
        dentalayurvedaSaveStatus: action.payload.success,
      };
    case GETDENTALAYURVEDA:
      return {
        ...state,
        dentalayurvedaList: action.payload.data,
      };
    case UPDATEDENTALAYURVEDA:
      return {
        ...state,
        dentalayurvedaUpdateStatus: action.payload.success,
      };

    case DELETEDENTALAYURVEDA:
      return {
        ...state,
        dentalayurvedaDeleteStatus: action.payload.success,
      };

    case CREATEDENTALHOMEOPATHIC:
      return {
        ...state,
        dentalhomeopathicSaveStatus: action.payload.success,
      };
    case GETDENTALHOMEOPATHIC:
      return {
        ...state,
        dentalhomeopathicList: action.payload.data,
      };
    case UPDATEDENTALHOMEOPATHIC:
      return {
        ...state,
        dentalhomeopathicUpdateStatus: action.payload.success,
      };

    case DELETEDENTALHOMEOPATHIC:
      return {
        ...state,
        dentalhomeopathicDeleteStatus: action.payload.success,
      };

    case CREATEDENTALOTHERMEDICINE:
      return {
        ...state,
        dentalothermedicineSaveStatus: action.payload.success,
      };
    case GETDENTALOTHERMEDICINE:
      return {
        ...state,
        dentalothermedicineList: action.payload.data,
      };
    case UPDATEDENTALOTHERMEDICINE:
      return {
        ...state,
        dentalothermedicineUpdateStatus: action.payload.success,
      };

    case DELETEDENTALOTHERMEDICINE:
      return {
        ...state,
        dentalothermedicineDeleteStatus: action.payload.success,
      };

    case CREATEDENTALANXIETY:
      return {
        ...state,
        dentalAnxietySaveStatus: action.payload.success,
      };
    case GETDENTALANXIETY:
      return {
        ...state,
        dentalAnxietyList: action.payload.data,
      };
    case UPDATEDENTALANXIETY:
      return {
        ...state,
        dentalAnxietyUpdateStatus: action.payload.success,
      };
    case DELETEDENTALANXIETY:
      return {
        ...state,
        dentalAnxietyDeleteStatus: action.payload.success,
      };

    case CREATEDENTALDEPRESSION:
      return { ...state, dentalDepressionSaveStatus: action.payload.success };
    case GETDENTALDEPRESSION:
      return { ...state, dentalDepressionList: action.payload.data };
    case UPDATEDENTALDEPRESSION:
      return { ...state, dentalDepressionUpdateStatus: action.payload.success };
    case DELETEDENTALDEPRESSION:
      return { ...state, dentalDepressionDeleteStatus: action.payload.success };

    case CREATEDENTALIRRITABILITY:
      return { ...state, dentalIrritabilitySaveStatus: action.payload.success };
    case GETDENTALIRRITABILITY:
      return { ...state, dentalIrritabilityList: action.payload.data };
    case UPDATEDENTALIRRITABILITY:
      return {
        ...state,
        dentalIrritabilityUpdateStatus: action.payload.success,
      };
    case DELETEDENTALIRRITABILITY:
      return {
        ...state,
        dentalIrritabilityDeleteStatus: action.payload.success,
      };

    case CREATEDENTALEUPHORIA:
      return { ...state, dentalEuphoriaSaveStatus: action.payload.success };
    case GETDENTALEUPHORIA:
      return { ...state, dentalEuphoriaList: action.payload.data };
    case UPDATEDENTALEUPHORIA:
      return { ...state, dentalEuphoriaUpdateStatus: action.payload.success };
    case DELETEDENTALEUPHORIA:
      return { ...state, dentalEuphoriaDeleteStatus: action.payload.success };

    case CREATEDENTALOBSESSION:
      return { ...state, dentalObsessionSaveStatus: action.payload.success };
    case GETDENTALOBSESSION:
      return { ...state, dentalObsessionList: action.payload.data };
    case UPDATEDENTALOBSESSION:
      return { ...state, dentalObsessionUpdateStatus: action.payload.success };
    case DELETEDENTALOBSESSION:
      return { ...state, dentalObsessionDeleteStatus: action.payload.success };

    case CREATEDENTALNEUROSIS:
      return { ...state, dentalNeurosisSaveStatus: action.payload.success };
    case GETDENTALNEUROSIS:
      return { ...state, dentalNeurosisList: action.payload.data };
    case UPDATEDENTALNEUROSIS:
      return { ...state, dentalNeurosisUpdateStatus: action.payload.success };
    case DELETEDENTALNEUROSIS:
      return { ...state, dentalNeurosisDeleteStatus: action.payload.success };

    case CREATEDENTALDEPERSONALIZATION:
      return {
        ...state,
        dentalDepersonalizationSaveStatus: action.payload.success,
      };
    case GETDENTALDEPERSONALIZATION:
      return { ...state, dentalDepersonalizationList: action.payload.data };
    case UPDATEDENTALDEPERSONALIZATION:
      return {
        ...state,
        dentalDepersonalizationUpdateStatus: action.payload.success,
      };
    case DELETEDENTALDEPERSONALIZATION:
      return {
        ...state,
        dentalDepersonalizationDeleteStatus: action.payload.success,
      };

    case CREATEDENTALMENSTRUALCYCLE:
      return {
        ...state,
        dentalMenstrualCycleSaveStatus: action.payload.success,
      };
    case GETDENTALMENSTRUALCYCLE:
      return { ...state, dentalMenstrualCycleList: action.payload.data };
    case UPDATEDENTALMENSTRUALCYCLE:
      return {
        ...state,
        dentalMenstrualCycleUpdateStatus: action.payload.success,
      };
    case DELETEDENTALMENSTRUALCYCLE:
      return {
        ...state,
        dentalMenstrualCycleDeleteStatus: action.payload.success,
      };

    case CREATEDENTALFILLINGMATERIAL:
      return {
        ...state,
        dentalFillingMaterialSaveStatus: action.payload.success,
      };
    case GETDENTALFILLINGMATERIAL:
      return { ...state, dentalFillingMaterialList: action.payload.data };
    case UPDATEDENTALFILLINGMATERIAL:
      return {
        ...state,
        dentalFillingMaterialUpdateStatus: action.payload.success,
      };
    case DELETEDENTALFILLINGMATERIAL:
      return {
        ...state,
        dentalFillingMaterialDeleteStatus: action.payload.success,
      };
    case CREATEDENTALFILLINGMATERIALUNIT:
      return {
        ...state,
        dentalFillingMaterialUnitSaveStatus: action.payload.success,
      };
    case GETDENTALFILLINGMATERIALUNIT:
      return { ...state, dentalFillingMaterialUnitList: action.payload.data };
    case UPDATEDENTALFILLINGMATERIALUNIT:
      return {
        ...state,
        dentalFillingMaterialUnitUpdateStatus: action.payload.success,
      };
    case DELETEDENTALFILLINGMATERIALUNIT:
      return {
        ...state,
        dentalFillingMaterialUnitDeleteStatus: action.payload.success,
      };

    case CREATEDENTALCOVERINGMATERIAL:
      return {
        ...state,
        dentalCoveringMaterialSaveStatus: action.payload.success,
      };
    case GETDENTALCOVERINGMATERIAL:
      return { ...state, dentalCoveringMaterialList: action.payload.data };
    case UPDATEDENTALCOVERINGMATERIAL:
      return {
        ...state,
        dentalCoveringMaterialUpdateStatus: action.payload.success,
      };
    case DELETEDENTALCOVERINGMATERIAL:
      return {
        ...state,
        dentalCoveringMaterialDeleteStatus: action.payload.success,
      };

    case CREATEDENTALCOVERINGMATERIALUNIT:
      return {
        ...state,
        dentalCoveringMaterialUnitSaveStatus: action.payload.success,
      };
    case GETDENTALCOVERINGMATERIALUNIT:
      return { ...state, dentalCoveringMaterialUnitList: action.payload.data };
    case UPDATEDENTALCOVERINGMATERIALUNIT:
      return {
        ...state,
        dentalCoveringMaterialUnitUpdateStatus: action.payload.success,
      };
    case DELETEDENTALCOVERINGMATERIALUNIT:
      return {
        ...state,
        dentalCoveringMaterialUnitDeleteStatus: action.payload.success,
      };

    case CREATEDENTALSTATUS:
      return { ...state, dentalStatusSaveStatus: action.payload.success };
    case GETDENTALSTATUS:
      return { ...state, dentalStatusList: action.payload.data };
    case UPDATEDENTALSTATUS:
      return { ...state, dentalStatusUpdateStatus: action.payload.success };
    case DELETEDENTALSTATUS:
      return { ...state, dentalStatusDeleteStatus: action.payload.success };

    case CREATEDENTALDIET:
      return { ...state, dentalDentalSaveStatus: action.payload.success };
    case GETDENTALDIET:
      return { ...state, dentalDietList: action.payload.data };
    case UPDATEDENTALDIET:
      return { ...state, dentalDentalUpdateStatus: action.payload.success };
    case DELETEDENTALDIET:
      return { ...state, dentalDentalDeleteStatus: action.payload.success };

    case CREATEDENTALNATUREOFDELIVERYHIST:
      return {
        ...state,
        dentalNatureofdiliverySaveStatus: action.payload.success,
      };
    case GETDENTALNATUREOFDELIVERYHIST:
      return { ...state, dentalNatureofdiliveryList: action.payload.data };
    case UPDATEDENTALNATUREOFDELIVERYHIST:
      return {
        ...state,
        dentalNatureofdiliveryUpdateStatus: action.payload.success,
      };
    case DELETEDENTALNATUREOFDELIVERYHIST:
      return {
        ...state,
        dentalNatureofdiliveryDeleteStatus: action.payload.success,
      };

    case CREATESETUPDIAGNOSIS:
      return {
        ...state,
        dentaldiagnosisSaveStatus: action.payload.success,
      };
    case GETSETUPDIAGNOSIS:
      console.log("Reducer Received Data:", action.payload); // ✅ Debug Redux state
      return {
        ...state,
        dentaldiagnosisList: action.payload.data,
      };
    case UPDATESETUPDIAGNOSIS:
      return {
        ...state,
        dentaldiagnosisUpdateStatus: action.payload.success,
      };
    case DELETESETUPDIAGNOSIS:
      return {
        ...state,
        dentaldiagnosisDeleteStatus: action.payload.success,
      };






    case CREATESETUPLABWORKMATERIALUSED:
      return {
        ...state,
        labworkmaterialusedSaveStatus: action.payload.success,
      };
    case GETSETUPLABWORKMATERIALUSED:
              return { ...state, labworkmaterialusedList: action.payload.data };
    case UPDATESETUPLABWORKMATERIALUSED:
      return {
        ...state,
        labworkmaterialusedUpdateStatus: action.payload.success,
      };
    case DELETESETUPLABWORKMATERIALUSED:
      return {
        ...state,
        labworkmaterialusedDeleteStatus: action.payload.success,
      };

    case CREATESETUPLABWORKUNIT:
      return {
        ...state,
        labworkunitSaveStatus: action.payload.success,
      };
    case GETSETUPLABWORKUNIT:
      return {
        ...state,
        labworkunitList: action.payload.data,
      };
    case UPDATESETUPLABWORKUNIT:
      return {
        ...state,
        labworkunitUpdateStatus: action.payload.success,
      };
    case DELETESETUPLABWORKUNIT:
      return {
        ...state,
        labworkunitDeleteStatus: action.payload.success,
      };

    case CREATESETUPLABWORKSTATUS:
      return {
        ...state,
        labworkstatusSaveStatus: action.payload.success,
      };
    case GETSETUPLABWORKSTATUS:
      return {
        ...state,
        labworkstatusList: action.payload.data,
      };
    case UPDATESETUPLABWORKSTATUS:
      return {
        ...state,
        labworkstatusUpdateStatus: action.payload.success,
      };
    case DELETESETUPLABWORKSTATUS:
      return {
        ...state,
        labworkstatusDeleteStatus: action.payload.success,
      };

    case CREATESETUPLABWORKSHADE:
      return {
        ...state,
        labworkshadeSaveStatus: action.payload.success,
      };
    case GETSETUPLABWORKSHADE:
      return {
        ...state,
        labworkshadeList: action.payload.data,
      };
    case UPDATESETUPLABWORKSHADE:
      return {
        ...state,
        labworkshadeUpdateStatus: action.payload.success,
      };
    case DELETESETUPLABWORKSHADE:
      return {
        ...state,
        labworkshadeDeleteStatus: action.payload.success,
      };

    case CREATESETUPLABWORKLABNAME:
      return {
        ...state,
        labworklabnameSaveStatus: action.payload.success,
      };
    case GETSETUPLABWORKLABNAME:
      return {
        ...state,
        labworklabnameList: action.payload.data,
      };
    case UPDATESETUPLABWORKLABNAME:
      return {
        ...state,
        labworklabnameUpdateStatus: action.payload.success,
      };
    case DELETESETUPLABWORKLABNAME:
      return {
        ...state,
        labworklabnameDeleteStatus: action.payload.success,
      };

      case CREATESETUPLABWORKRESTORATION:
        return {
          ...state,
          labworkrestorationaveStatus: action.payload.success,
        };
      case GETSETUPLABWORKRESTORATION:
                return { ...state, labworkrestorationList: action.payload.data };
      case UPDATESETUPLABWORKRESTORATION:
        return {
          ...state,
          labworkrestorationUpdateStatus: action.payload.success,
        };
      case DELETESETUPLABWORKRESTORATION:
        return {
          ...state,
          labworkrestorationDeleteStatus: action.payload.success,
        };

    default:
      return state;
  }
}
